<template>
  <SettingsSection>
    <SettingsSectionTitle> VAT </SettingsSectionTitle>
    <SettingsSubsection>
      <SettingsVATForm />
    </SettingsSubsection>
  </SettingsSection>
</template>
